import styles from "./race-hub.module.scss"
import { useEffect, useRef, useState } from "react"

// UI components
import Background from "../../components/background/background"
import Location from "./slides/location/location"
import Schedule from "./slides/schedule/schedule"
import Standings from "./slides/standings/standings"
import Arrow from "../../assets/images/icons/arrow.svg"

// Returns the HTML makrup for the race hub
export default function RaceHub() {
	const [isFadedOutSwipe, setIsFadedOutSwipe] = useState(false)

	// Scroll position trackers
	const [baseScrollPosition, setBaseScrollPosition] = useState(0)
	const [scrollPosition, setScrollPosition] = useState(50)

	// Ref to the slider
	const sliderRef = useRef(null)

	// Handle the scroll event
	const handleScroll = () => {
		// If the div ref is available
		if (sliderRef.current) {
			// Get the scroll left and screen width
			const scrollLeft = sliderRef.current.scrollLeft
			const screenWidth = window.innerWidth

			// Set the base scroll position into the state for the background
			setBaseScrollPosition(scrollLeft)

			// Work out the scroll left as a percentage of the screen width
			setScrollPosition((scrollLeft / screenWidth) * 100 * -0.25 + 50)

			// Only fade out the arrow when the user is scrolling to the third slide
			// This happens when scrollLeft is approximately 2x the screen width
			setIsFadedOutSwipe(scrollLeft > screenWidth * 1.5)
		}
	}

	// On component mount
	useEffect(() => {
		// If the div ref is available
		if (sliderRef.current) {
			// Add event listener
			sliderRef.current.addEventListener("scroll", handleScroll)
		}

		// Cleanup event listener
		return () => {
			if (sliderRef.current) {
				sliderRef.current.removeEventListener("scroll", handleScroll)
			}
		}
	}, [])

	return (
		<>
			<Background />
			<div
				className={styles.slider}
				ref={sliderRef}>
				<div className={styles.slide}>
					<Location />
				</div>
				<div className={styles.slide}>
					<Schedule />
				</div>
				<div className={styles.slide}>
					<Standings />
				</div>
			</div>

			<div className={[styles.swipe, isFadedOutSwipe ? styles.fadeOut : ""].join(" ").trim()}>
				<img
					src={Arrow}
					alt="Left Arrow"
				/>
			</div>
		</>
	)
}
